import React, { useState } from "react";

import { ConfirmDialog } from "../../../../components/SyDialog";
import { getLabel } from "../../../../hooks/use-labels";
import { handleError } from "../../../../utils/common-utils";

import { performUserLogout } from "../profile-item-utils";

import "../../../../features/checkout/styles.css";

const LogoutConfirmation = ({ onClose, onLoggedOut }) => {
  const [loading, setLoading] = useState(false);

  /**
   * Tell the backend, then log out locally whatever it answered.
   *
   * The server call used to be the whole handler. That worked only on the old
   * backend, where `publish-logout/{deviceId}` pushed a `device_logout` socket
   * event back and the socket listener did the real work. The new route has no
   * such event, so confirming left the session intact and the modal spinning.
   *
   * It stays ordered this way because the call needs the bearer that
   * `onLoggedOut` is about to clear.
   */
  const onConfirmLogout = () => {
    setLoading(true);

    performUserLogout()
      .catch((error) => {
        const message = handleError(error);
        console.error({ message });
      })
      .finally(() => onLoggedOut());
  };

  return (
    <ConfirmDialog
      title="Log out"
      message={getLabel("logoutConfirmation")}
      tone="brand"
      confirmText={getLabel("yesLabel")}
      cancelText={getLabel("noLabel")}
      busy={loading}
      onConfirm={onConfirmLogout}
      onCancel={loading ? () => {} : onClose}
    />
  );
};

export default LogoutConfirmation;
